import LogoutIcon from '@mui/icons-material/Logout';
import { Avatar, Box, Button, Divider, IconButton, Popover, Stack, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { CommonHelper } from 'src/utils/commonHelper';

export default function GetStartedTopBar() {
  const { t: translate } = useTranslation();
  const [anchorEl, setAnchorEl] = useState(null);
  const [user, setUser] = useState({});
  const appLogo = CommonHelper.GetAppLogo();
  const appName = CommonHelper.GetAppName() || 'Brand2Chat';
  const userName = [user.first_name, user.last_name].filter(Boolean).join(' ') || user.email || 'User';

  useEffect(() => {
    setUser(CommonHelper.GetBrandInfoFromLocalStorage('user_details') || {});
  }, []);

  const handleLogout = () => {
    setAnchorEl(null);
    CommonHelper.Logout();
  };

  return (
    <Box
      component="header"
      sx={{
        height: 86,
        bgcolor: 'background.paper',
        borderBottom: '1px solid',
        borderColor: 'divider',
      }}
    >
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        sx={{ height: 1, maxWidth: 1180, mx: 'auto', px: { xs: 2, md: 3 } }}
      >
        <Stack direction="row" alignItems="center" spacing={1.5}>
          <Box component="img" src={appLogo} alt={appName} sx={{ width: 46, height: 46, objectFit: 'contain' }} />
          <Box>
            <Typography variant="h5" fontWeight={900} lineHeight={1.08}>
              {appName}
            </Typography>
            <Typography variant="body2" color="text.secondary" fontWeight={700}>
              {translate('get_started_page.workspace_setup', { defaultValue: 'Workspace setup' })}
            </Typography>
          </Box>
        </Stack>

        <IconButton onClick={(event) => setAnchorEl(event.currentTarget)} sx={{ p: 0 }}>
          <Avatar src={user.image_url || ''} alt={userName} sx={{ bgcolor: 'primary.main' }}>
            {userName.charAt(0).toUpperCase()}
          </Avatar>
        </IconButton>

        <Popover
          open={Boolean(anchorEl)}
          anchorEl={anchorEl}
          onClose={() => setAnchorEl(null)}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
          transformOrigin={{ vertical: 'top', horizontal: 'right' }}
          PaperProps={{ sx: { mt: 1.5, width: 240, borderRadius: 1.5 } }}
        >
          <Box sx={{ px: 2, py: 1.5 }}>
            <Typography variant="subtitle2" noWrap>
              {userName}
            </Typography>
            <Typography variant="body2" color="text.secondary" noWrap>
              {user.email}
            </Typography>
          </Box>
          <Divider />
          <Box sx={{ p: 1 }}>
            <Button fullWidth color="error" startIcon={<LogoutIcon />} onClick={handleLogout} sx={{ justifyContent: 'flex-start' }}>
              {translate('get_started_page.logout', { defaultValue: 'Logout' })}
            </Button>
          </Box>
        </Popover>
      </Stack>
    </Box>
  );
}
